import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'invitations/access' },
  {
    path: 'invitations/access',
    loadComponent: () =>
      import('./invitation-access/invitation-access').then((m) => m.InvitationAccessComponent),
  },
  { path: '**', redirectTo: 'invitations/access' },
];
